import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AuthService } from '../../auth/auth.service';
import { TaskService } from '../../shared/services/task.service';
import { UserService } from '../../shared/services/user.service';
import { DateTime } from 'luxon';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-add-task',
  templateUrl: './add-task.component.html',
  styleUrls: ['./add-task.component.scss']
})
export class AddTaskComponent implements OnInit {

  @Input() caseId: number;
  @Input() isNote = false;
  @Input() taskId: number;

  taskForm = new UntypedFormGroup({
    dueByDate: new UntypedFormControl('', Validators.required),
    entry: new UntypedFormControl('', Validators.required),
  });

  maxDate: string = '';
  minDate: string = '';

  title = '';
  invalidSelection: boolean = true;

  users: any[] = [];
  selectedUser: any = null;

  constructor(
    public activeModal: NgbActiveModal,
    private authService: AuthService,
    private taskService: TaskService,
    private userService: UserService) {

    userService.adminsAndParalegals().subscribe((results: any) => {
      this.users = results
        .map((user: any) => ({ name: user.firstName + ' ' + user.lastName, id: user.id }))
        .sort((a: any, b: any) => a.name.localeCompare(b.name));
    });
  }

  ngOnInit(): void {
    if (this.isNote) {
      this.title = 'Add Note to Task';
      this.taskForm.get('dueByDate')!.clearValidators();
      this.invalidSelection = false;
    } else {
      this.title = 'Add Task';
    }

    this.minDate = DateTime.local().toFormat('yyyy-MM-dd');
    this.maxDate = DateTime.local().plus({ months: 3 }).toFormat('yyyy-MM-dd');
  }

  save() {
    if (this.isNote) {
      this.addNote();
    } else {
      this.addTask();
    }
  }

  addNote() {
    const reply = {
      entry: this.taskForm.get('entry')!.value
    };

    this.taskService.addTaskReply(this.taskId, reply).subscribe(() => {
      this.activeModal.close(true);
    });
  }

  addTask() {
    this.checkValid();

    if (!this.invalidSelection) {
      const task = {
        caseId: this.caseId,
        createdByUserId: this.authService.currentUserID(),
        createdForUserId: this.selectedUser.id,
        entry: this.taskForm.get('entry')!.value,
        dueByDate: this.taskForm.get('dueByDate')!.value
      };

      this.taskService.addTask(task).subscribe(() => {
        this.activeModal.close(true);
      });
    }
  }

  checkValid() {
    if (this.isNote) {
      this.invalidSelection = false;
    } else {
      this.invalidSelection = !(
        this.selectedUser?.id > 0 &&
        this.taskForm.get('entry')!.value &&
        this.taskForm.get('dueByDate')!.value
      );
    }
  }

  cancel() {
    this.activeModal.close(false);
  }
}